import http from '@/api/http'
import { API_BASE_URL } from '@/config/env'
import {
  emptyModifierTemplates,
  mapModifierTemplatesPayload,
  mapToppingOptionsPayload,
} from '@/entities/admin/lib/mapModifierTemplates'
import { mapAdminRestaurant } from '@/entities/admin/model/mapAdminRestaurant'
import { mapRestaurant } from '@/entities/restaurant/model/mapRestaurant'
import { adminList, adminRequest } from '@/entities/admin/api/adminRequest'

const LIST_PATH = '/admin/restaurants'

export const ADMIN_RESTAURANTS_PAGE_SIZE = 20

function hasAdminRestaurantsApi() {
  return Boolean(API_BASE_URL)
}

export async function fetchAdminRestaurants({
  limit = ADMIN_RESTAURANTS_PAGE_SIZE,
  skip = 0,
  filter = {},
  sort = {},
} = {}) {
  if (!hasAdminRestaurantsApi()) {
    return { items: [], total: 0 }
  }

  const payload = await adminList(LIST_PATH, { limit, skip, filter, sort })
  const list = Array.isArray(payload.data) ? payload.data.map((item) => mapRestaurant(item)) : []
  return {
    items: list,
    total: Number(payload.total) || list.length,
  }
}

export async function fetchAdminRestaurantById(id) {
  if (!id || !hasAdminRestaurantsApi()) {
    return null
  }

  const payload = await adminRequest(() => http.get(`/admin/restaurant/${id}`))
  return mapAdminRestaurant(payload.data)
}

export async function createAdminRestaurant(body) {
  const payload = await adminRequest(() => http.post('/admin/restaurant', body))
  return mapAdminRestaurant(payload.data)
}

export async function updateAdminRestaurant(id, body) {
  const payload = await adminRequest(() => http.post(`/admin/restaurant/${id}/update`, body))
  return mapAdminRestaurant(payload.data)
}

export async function fetchAdminModifierTemplates(restoId) {
  const id = String(restoId ?? '').trim()
  if (!id || !hasAdminRestaurantsApi()) {
    return emptyModifierTemplates()
  }

  const payload = await adminRequest(() =>
    http.get(`/admin/restaurant/${id}/modifier-templates`),
  )
  return mapModifierTemplatesPayload(payload.data)
}

export async function fetchAdminToppingOptions(restoId) {
  const id = String(restoId ?? '').trim()
  if (!id || !hasAdminRestaurantsApi()) {
    return []
  }

  const payload = await adminRequest(() =>
    http.get(`/admin/restaurant/${id}/topping-options`),
  )
  return mapToppingOptionsPayload(payload.data)
}
